export const LogSteps = [
	{
		selector: '[data-tour="my-requests"]',
		content: 'List of requests submitted by you',
	},
	{
		selector: '[data-tour="my-contributions"]',
		content: 'Detailed list of your contributions as a Hub or Angel.',
	},
];
